import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Custom Components
import ModelTable from '@/ui/Table/ModelTable';
import DataController, { IDataController } from '@/lib/DataController';
import model from '@/models/pristupacnost/grading';

// Types
import { DCRecord } from '@/@types/lib/dataController';

const GradingTable = () => {
  const { t } = useTranslation();
  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new DataController(model);

  // FUNCTIONS
  //---------------------------------------------------------------------------------------------------

  const refreshRecords = () => {
    dc.GetData().then((resp) => {
      if (resp.success) {
        if (Array.isArray(resp.data)) {
          setRecords(resp.data);
        } else {
          setRecords([]);
        }
      }
    });
  };

  // EFFECTS
  //---------------------------------------------------------------------------------------------------

  useEffect(() => {
    refreshRecords();
  }, []);

  // RETURN
  //---------------------------------------------------------------------------------------------------

  return (
    <ModelTable
      title={t('pristupacnost:titles.evaluacija_objekata')}
      records={records}
      dc={dc}
      viewName='history'
      allowSelection="one"
      allowFilter
      allowExport
      allowColumnPicker
      onRowAction={() => {}}
      allowRowAction={() => true}
      defaultPageSize={25}
    />
  );
};

export default GradingTable;
